<mat-icon svgIcon="{{svgIcon}}"></mat-icon>